module.exports = __webpack_public_path__ + "static/img/qmwallet2-benefit-item-bg.16826a92.png";